<template>
  <div class="content-8">
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">今日号码统计</span>
        </div>
      </div>
    </div>
    <loading v-if="isLoading" />
    <template v-else>
      <template v-if="Object.keys(jinRiHaoMaStatsList).length > 0">
        <div class="content-8__controlbar">
          <div class="content-8__controlbar__item">
            <div class="c8-explanation">
              <span class="c8-explanation__title">说明：</span>
              <div class="c8-explanation__content">
                <p>{{ explainationText }}</p>
              </div>
            </div>
            <div class="c8-select">
              <div class="c8-select__title">
                <span class="c8-select__text">
                  数值标示颜色: 15-30
                  <span class="red">红色</span>, 31-40
                  <span class="blue">蓝色</span>, 41-50
                  <span class="green">绿色</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="content-8__content">
          <table class="even-color">
            <thead>
              <tr>
                <th rowspan="2">
                  <span>号码</span>
                </th>
                <th
                  v-for="column in columnKeys"
                  :key="column.key"
                  colspan="2"
                >{{ column.columnLabel }}</th>
              </tr>
              <tr>
                <template v-for="colIndex in columnKeys.length">
                  <template v-for="subCol in subColKeys">
                    <th :key="`${colIndex}-${subCol.key}`">{{ subCol.label }}</th>
                  </template>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in rowKeys" :key="row.key">
                <td>
                  <div class="tableballbox__item">
                    <div class="ball size-middle" :class="row.class">
                      <span class="ball__number">{{ row.val }}</span>
                    </div>
                  </div>
                </td>
                <template v-for="column in columnKeys">
                  <template v-for="subCol in subColKeys">
                    <td
                      :key="`tbody-${column.key}-${subCol.key}`"
                      :class="bindTextColor(Math.abs(jinRiHaoMaStatsList[column.key][subCol.key][row.key]))"
                    >{{ Math.abs(jinRiHaoMaStatsList[column.key][subCol.key][row.key]) }}</td>
                  </template>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
      <NoData v-else />
    </template>
  </div>
</template>

<script>
import { fieldList } from '@/utils/forWeb-Sean/jinRiHaoMa'
import { getCPStatistics_web } from '@/api/desktop/statistic'

import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'
export default {
  name: 'JinRiHaoMaTongJi',
  components: {
    Loading,
    NoData
  },
  props: {
    lotteryType: {
      type: String,
      default: '',
      requried: true
    }
  },
  data() {
    return {
      isLoading: false,
      lotteryCode: this.$route.params.lottery_code,
      jinRiHaoMaStatsList: null
    }
  },
  computed: {
    ...fieldList,
    explainationText() {
      switch (this.lotteryType) {
        case 'pk10':
          return '统计每个位置（冠军、亚军…第十名）每一个号码（1~10）今日开出的总次数，及近期未开出（遗漏）次数。'
        case 'ssc':
        case '11x5':
        case 'kl10':
        default:
          return '提供各球位号码当日的开出次数及近期未开次数。'
      }
    }
  },
  created() {
    this.getTodayNumberStatistics(this.lotteryCode)
  },
  methods: {
    async getTodayNumberStatistics(code) {
      this.isLoading = true
      const [data, error] = await getCPStatistics_web(
        code,
        'todayNumberStatistics'
      )
      if (error) return
      this.jinRiHaoMaStatsList = data || {}
      this.isLoading = false
    },
    bindTextColor(number) {
      if (number >= 15 && number <= 30) return 'red'
      else if (number >= 31 && number <= 40) return 'blue'
      if (number >= 41 && number <= 50) return 'green'
    }
  }
}
</script>

